<section class="container">
  <div>
    <textarea dir="ltr" class="text-left" #settingsJson [value]="settings|json" style="height: 60vh;"></textarea>
  </div>
  <div>
    <button class="btn btn-primary" (click)="save(settingsJson.value)" >Save</button>
  </div>
</section>
